import React from 'react';
import { useState, useEffect } from 'react';
import { FormWithMargin } from '../styles/styledComponents';
import TextField from '@mui/material/TextField';
import { useTextEntry } from './textEntry';
import { isAlphaNumericWithHyphens, isAlphaNumericWithUnderScores } from '../utils/validation';
import { useOptionSelect } from './optionSelect'
import { Typography } from '@mui/material';
import { HeaderData } from '../utils/types';

export function isValidHeader(header: HeaderData) {
    return isAlphaNumericWithHyphens(header.destinationHeader) 
    && isAlphaNumericWithUnderScores(header.value) 
    && header.source !== '';
}
const SOURCE_OPTIONS = [
    {name: "Token", value: "Token"},
    {name: "Raw", value: "Raw"}
];
export function useHeaderEditor(
    displayError: boolean,
    destinationHeader: string = '',
    value: string = '',
    source: string = ''
) {

    const {
        component: destinationComponent,
        value: destinationValue,
        setValue: setDestination,
        isValid: destinationIsValid
    } = useTextEntry(
        destinationHeader,
        displayError,
        'Destination Header',
        isAlphaNumericWithHyphens
    );
    
    const {
        component: valueComponent,
        value: valueValue,
        setValue: setValue,
        isValid: valueIsValid
    } = useTextEntry(
        value,
        displayError,
        'Value',
        isAlphaNumericWithUnderScores
    );

    const {
        component: sourceComponent,
        selectedOption: sourceValue,
        setSelection: setSource,
        isOptionSelected: sourceIsSelected
    } = useOptionSelect(
        'Source',
        SOURCE_OPTIONS,
        displayError,
    );
    
    const setHeader = (header: HeaderData) => {
        if(!header) return;
        setDestination(header.destinationHeader);
        setValue(header.value);
        setSource(header.source);
    }

    const component =  <FormWithMargin>
        <Typography>Edit Header</Typography>
        {destinationComponent}
        {valueComponent}
        {sourceComponent}
    </FormWithMargin>

    const isValid = destinationIsValid && valueIsValid && sourceIsSelected;
    const headerData: HeaderData = {
        destinationHeader: destinationValue,
        value: valueValue,
        source: sourceValue
    };

    return {
        component,
        isValid,
        headerData,
        setHeader
    } 
}
